import { FormControl } from '@angular/forms';

export class DoingBusinessAsItem {
    control: FormControl;
    name: string;
}
